import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { auth, db } from '../FirebaseComp/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc, addDoc, query, orderBy, onSnapshot, limit, where, serverTimestamp } from 'firebase/firestore';

import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import './driver.css';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faSpinner, faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




function DriverPanel() {
  const [activeTab, setActiveTab] = useState('myProfile'); // Default tab
  const [users, setUsers] = useState([]);




  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);





//fetch driver's profile
 const [driver, setDriver] = useState(null);

  useEffect(() => {
    const fetchDriver = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          // Query drivers collection where email == current user email
          const q = query(
            collection(db, "drivers"),
            where("email", "==", user.email)
          );
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            setDriver(querySnapshot.docs[0].data());
          } else {
            console.log("No driver profile found!");
          }
        } catch (error) {
          console.error("Error fetching profile:", error);
        }
      }
    };

    fetchDriver();
  }, []);





//reach support team of chavo tours
  const [formData, setFormData] = useState({
    queryType: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // Fetch driver details
  useEffect(() => {
    const fetchDriver = async () => {
      const user = auth.currentUser;
      if (user) {
        const q = query(
          collection(db, "drivers"),
          where("email", "==", user.email)
        );
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          setDriver(snapshot.docs[0].data());
        }
      }
    };
    fetchDriver();
  }, []);

  // Handle form change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.queryType || !formData.subject || !formData.message) {
      alert("Please fill in all fields!");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(db, "support"), {
        name: driver?.name || "",
        email: driver?.email || "",
        queryType: formData.queryType,
        subject: formData.subject,
        message: formData.message,
        createdAt: new Date(),
      });
      setSuccess(true);
      setFormData({ queryType: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error submitting support request:", error);
    }
    setLoading(false);
  };





//fetch tours
// State for My Rides
const [myRides, setMyRides] = useState([]);
const [myRidesLoading, setMyRidesLoading] = useState(false);
const [myRidesError, setMyRidesError] = useState('');
const [ridesFilter, setRidesFilter] = useState('all');
const [ridesSort, setRidesSort] = useState('newest');

// Get current user email (you might need to adjust this based on your auth setup)
const currentUserEmail = auth.currentUser?.email;

// Fetch user's rides
const fetchMyRides = async () => {
  if (!currentUserEmail) return;
  
  try {
    setMyRidesLoading(true);
    setMyRidesError('');
    
    const ridesQuery = query(
      collection(db, 'tours'),
      where('driverEmail', '==', currentUserEmail)
    );
    
    const querySnapshot = await getDocs(ridesQuery);
    const ridesData = [];
    
    querySnapshot.forEach((doc) => {
      ridesData.push({ id: doc.id, ...doc.data() });
    });
    
    setMyRides(ridesData);
  } catch (err) {
    console.error('Error fetching user rides:', err);
    setMyRidesError('Failed to load your rides. Please try again.');
  } finally {
    setMyRidesLoading(false);
  }
};

// Filter and sort rides
const filteredAndSortedRides = useMemo(() => {
  let filtered = myRides;
  
  // Apply filter
  if (ridesFilter !== 'all') {
    filtered = filtered.filter(ride => ride.status === ridesFilter);
  }
  
  // Apply sorting
  return filtered.sort((a, b) => {
    switch (ridesSort) {
      case 'newest':
        return new Date(b.tourDate + 'T' + b.tourTime) - new Date(a.tourDate + 'T' + a.tourTime);
      case 'oldest':
        return new Date(a.tourDate + 'T' + a.tourTime) - new Date(b.tourDate + 'T' + b.tourTime);
      case 'price-high':
        return Number(b.tourCharges) - Number(a.tourCharges);
      case 'price-low':
        return Number(a.tourCharges) - Number(b.tourCharges);
      default:
        return 0;
    }
  });
}, [myRides, ridesFilter, ridesSort]);

// Handle ride actions
const handleViewRideDetails = (ride) => {
  // Implement view ride details modal
  console.log('View ride details:', ride);
};

const handleCancelRide = async (rideId) => {
  if (!window.confirm('Are you sure you want to cancel this ride?')) {
    return;
  }
  
  try {
    await updateDoc(doc(db, 'tours', rideId), {
      status: 'cancelled',
      cancelledAt: serverTimestamp()
    });
    
    toast.success('Ride cancelled successfully');
    fetchMyRides(); // Refresh the list
  } catch (err) {
    console.error('Error cancelling ride:', err);
    toast.error('Failed to cancel ride');
  }
};

// Fetch rides when the tab is active
useEffect(() => {
  if (activeTab === 'viewMyRides' && currentUserEmail) {
    fetchMyRides();
  }
}, [activeTab, currentUserEmail]);













//my earnings of the driver

// State for Earnings
const [earningsData, setEarningsData] = useState([]);
const [earningsLoading, setEarningsLoading] = useState(false);
const [earningsError, setEarningsError] = useState('');

// Calculate earnings metrics
const totalEarnings = useMemo(() => {
  return earningsData
    .filter(ride => ride.status === 'completed')
    .reduce((total, ride) => total + Number(ride.tourCharges || 0), 0);
}, [earningsData]);

const totalRides = useMemo(() => {
  return earningsData.filter(ride => ride.status === 'completed').length;
}, [earningsData]);

const averagePerRide = useMemo(() => {
  return totalRides > 0 ? Math.round(totalEarnings / totalRides) : 0;
}, [totalEarnings, totalRides]);

const upcomingEarnings = useMemo(() => {
  return earningsData
    .filter(ride => ride.status === 'scheduled')
    .reduce((total, ride) => total + Number(ride.tourCharges || 0), 0);
}, [earningsData]);

const scheduledRides = useMemo(() => {
  return earningsData.filter(ride => ride.status === 'scheduled').length;
}, [earningsData]);

const recentRides = useMemo(() => {
  return earningsData
    .sort((a, b) => new Date(b.tourDate + 'T' + b.tourTime) - new Date(a.tourDate + 'T' + a.tourTime))
    .slice(0, 5);
}, [earningsData]);

const monthlyEarnings = useMemo(() => {
  const months = {};
  const currentDate = new Date();
  
  earningsData
    .filter(ride => ride.status === 'completed')
    .forEach(ride => {
      const rideDate = new Date(ride.tourDate);
      const monthYear = `${rideDate.getFullYear()}-${rideDate.getMonth() + 1}`;
      const monthName = rideDate.toLocaleString('default', { month: 'short', year: 'numeric' });
      
      if (!months[monthYear]) {
        months[monthYear] = { month: monthName, amount: 0 };
      }
      months[monthYear].amount += Number(ride.tourCharges || 0);
    });
  
  return Object.values(months).sort((a, b) => {
    const [aYear, aMonth] = a.month.split(' ');
    const [bYear, bMonth] = b.month.split(' ');
    return new Date(bYear, bMonth) - new Date(aYear, aMonth);
  });
}, [earningsData]);

const maxMonthlyEarnings = useMemo(() => {
  return monthlyEarnings.length > 0 
    ? Math.max(...monthlyEarnings.map(month => month.amount)) 
    : 0;
}, [monthlyEarnings]);

const todayEarnings = useMemo(() => {
  const today = new Date().toDateString();
  return earningsData
    .filter(ride => ride.status === 'completed' && new Date(ride.tourDate).toDateString() === today)
    .reduce((total, ride) => total + Number(ride.tourCharges || 0), 0);
}, [earningsData]);

const weeklyEarnings = useMemo(() => {
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  
  return earningsData
    .filter(ride => ride.status === 'completed' && new Date(ride.tourDate) >= oneWeekAgo)
    .reduce((total, ride) => total + Number(ride.tourCharges || 0), 0);
}, [earningsData]);

// Fetch earnings data
const fetchEarningsData = async () => {
  if (!currentUserEmail) return;
  
  try {
    setEarningsLoading(true);
    setEarningsError('');
    
    const earningsQuery = query(
      collection(db, 'tours'),
      where('driverEmail', '==', currentUserEmail)
    );
    
    const querySnapshot = await getDocs(earningsQuery);
    const data = [];
    
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    
    setEarningsData(data);
  } catch (err) {
    console.error('Error fetching earnings data:', err);
    setEarningsError('Failed to load your earnings data. Please try again.');
  } finally {
    setEarningsLoading(false);
  }
};

// Download report function
const handleDownloadReport = () => {
  // Create a simple text report
  const report = `
    DRIVER EARNINGS REPORT
    ======================
    
    Total Earnings: LKR ${totalEarnings.toLocaleString()}
    Total Completed Rides: ${totalRides}
    Average per Ride: LKR ${averagePerRide.toLocaleString()}
    Upcoming Earnings: LKR ${upcomingEarnings.toLocaleString()}
    
    Monthly Breakdown:
    ${monthlyEarnings.map(month => `  - ${month.month}: LKR ${month.amount.toLocaleString()}`).join('\n')}
    
    Generated on: ${new Date().toLocaleDateString()}
  `;
  
  // Create download link
  const blob = new Blob([report], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `earnings-report-${new Date().toISOString().split('T')[0]}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Fetch earnings when the tab is active
useEffect(() => {
  if (activeTab === 'myEarnings' && currentUserEmail) {
    fetchEarningsData();
  }
}, [activeTab, currentUserEmail]);










  return (
    <div className="driver-panel">
      <div className="top-bar">
        <ul className="tabs">
          <li className={`tab ${activeTab === 'myProfile' ? 'active' : ''}`} onClick={() => handleTabClick('myProfile')}>
            My profile
          </li>

          <li className={`tab ${activeTab === 'viewMyRides' ? 'active' : ''}`} onClick={() => handleTabClick('viewMyRides')}>
           View My Rides
          </li>

          <li className={`tab ${activeTab === 'myEarnings' ? 'active' : ''}`} onClick={() => handleTabClick('myEarnings')}>
            My Earnings
          </li>


          <li className={`tab ${activeTab === 'reachSupport' ? 'active' : ''}`} onClick={() => handleTabClick('reachSupport')}>
            Reach Support Team
          </li>


        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">



{/******************************************************************************************************************************/}








{activeTab === "myProfile" && (
 <div className="my-profile-container">
      <h1 className="heading-my-profile">My Profile</h1>

      {driver ? (
        <div className="profile-card">
          <div className="profile-header">
            <img
              src={driver.imageUrl}
              alt="Profile"
              className="profile-avatar"
            />
            <h2>{driver.name}</h2>
            <p>{driver.email}</p>
          </div>

          <div className="profile-details">
            <h3>Personal Info</h3>
            <p><strong>NIC:</strong> {driver.nic}</p>
            <p><strong>Phone:</strong> {driver.phone}</p>
            <p><strong>WhatsApp:</strong> {driver.whatsapp}</p>
            <p><strong>Address:</strong> {driver.address}</p>
            <p><strong>City:</strong> {driver.city}</p>
            <p><strong>District:</strong> {driver.district}</p>
            <p><strong>Province:</strong> {driver.province}</p>

            <h3>Vehicle Info</h3>
            <p><strong>Driver ID:</strong> {driver.driverId}</p>
            <p><strong>Vehicle Name:</strong> {driver.vehicleName}</p>
            <p><strong>Vehicle Type:</strong> {driver.vehicleType}</p>
            <p><strong>Number Plate:</strong> {driver.numberPlate}</p>
            <p><strong>Rate per Km:</strong> Rs. {driver.ratePerKm}</p>
          </div>
        </div>
      ) : (
        <p>Loading profile...</p>
      )}
    </div>
)}




{/*************************************************************************************************************************************/}


{activeTab === "viewMyRides" && (
  <div className="view-my-rides-container">
    <h1 className='heading-view-my-rides'>My Rides</h1>
    
    {myRidesLoading ? (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading your rides...</p>
      </div>
    ) : myRidesError ? (
      <div className="error-container">
        <p className="error-message">{myRidesError}</p>
        <button 
          className="btn-retry"
          onClick={fetchMyRides}
        >
          Try Again
        </button>
      </div>
    ) : myRides.length === 0 ? (
      <div className="empty-state">
        <div className="empty-icon">🚗</div>
        <h3>No rides yet</h3>
        <p>You haven't taken any rides yet. Book your first ride to get started!</p>
      </div>
    ) : (
      <>
        <div className="rides-stats">
          <div className="stat-card">
            <span className="stat-number">{myRides.length}</span>
            <span className="stat-label">Total Rides</span>
          </div>
          {/* <div className="stat-card">
            <span className="stat-number">
              {myRides.filter(ride => ride.status === 'completed').length}
            </span>
            <span className="stat-label">Completed</span>
          </div> */}
          {/* <div className="stat-card">
            <span className="stat-number">
              {myRides.filter(ride => ride.status === 'scheduled').length}
            </span>
            <span className="stat-label">Upcoming</span>
          </div> */}
        </div>
        
        <div className="rides-filters">
          {/* <select 
            value={ridesFilter} 
            onChange={(e) => setRidesFilter(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Rides</option>
            <option value="scheduled">Upcoming</option>
            <option value="in-progress">In Progress</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
          </select> */}
          
          <select 
            value={ridesSort} 
            onChange={(e) => setRidesSort(e.target.value)}
            className="sort-select"
          >
            <option value="newest">Newest First</option>
            <option value="oldest">Oldest First</option>
            <option value="price-high">Price: High to Low</option>
            <option value="price-low">Price: Low to High</option>
          </select>
        </div>
        
        <div className="rides-list">
          {filteredAndSortedRides.map(ride => (
            <div key={ride.id} className="ride-card">
              <div className="ride-header">
                <div className="ride-id">Ride #{ride.tourId}</div>
                {/* <span className={`ride-status ride-status-${ride.status || 'scheduled'}`}>
                  {ride.status || 'Scheduled'}
                </span> */}
              </div>
              
              <div className="ride-route">
                <div className="route-point">
                  <span className="route-marker">📍</span>
                  <span className="route-location">{ride.pickupLocation}</span>
                </div>
                <div className="route-line"></div>
                <div className="route-point">
                  <span className="route-marker">🏁</span>
                  <span className="route-location">{ride.dropLocation}</span>
                </div>
              </div>
              
              <div className="ride-details">
                <div className="detail-item">
                  <span className="detail-label">Date & Time:</span>
                  <span className="detail-value">
                    {new Date(ride.tourDate).toLocaleDateString()} at {ride.tourTime}
                  </span>
                </div>
                
                <div className="detail-item">
                  <span className="detail-label">Driver:</span>
                  <span className="detail-value">{ride.driverName}</span>
                </div>
                
                <div className="detail-item">
                  <span className="detail-label">Vehicle:</span>
                  <span className="detail-value">
                    {ride.vehicleName} ({ride.vehicleType})
                  </span>
                </div>
                
                <div className="detail-item">
                  <span className="detail-label">Charges:</span>
                  <span className="detail-value price">LKR {ride.tourCharges}</span>
                </div>
                
                {ride.notes && (
                  <div className="detail-item">
                    <span className="detail-label">Notes:</span>
                    <span className="detail-value notes">{ride.notes}</span>
                  </div>
                )}
              </div>
              

            </div>
          ))}
        </div>
      </>
    )}
  </div>
)}

{/******************************************************************************************************************************/}


{activeTab === "myEarnings" && (
  <div className="my-earnings-container">
    <h1 className="heading-my-earnings">My Earnings</h1>
    
    {earningsLoading ? (
      <div className="earnings-loading">
        <div className="loading-spinner"></div>
        <p>Calculating your earnings...</p>
      </div>
    ) : earningsError ? (
      <div className="earnings-error">
        <p className="error-message">{earningsError}</p>
        <button 
          className="btn-retry"
          onClick={fetchEarningsData}
        >
          Try Again
        </button>
      </div>
    ) : (
      <>
        {/* Earnings Summary Cards */}
        <div className="earnings-summary">
          <div className="earnings-card total-earnings">
            <div className="card-icon">💰</div>
            <div className="card-content">
              <h3>Total Earnings</h3>
              <p className="amount">LKR {totalEarnings.toLocaleString()}</p>
              <p className="subtext">From {totalRides} completed rides</p>
            </div>
          </div>
          
          <div className="earnings-card average-earnings">
            <div className="card-icon">📊</div>
            <div className="card-content">
              <h3>Average per Ride</h3>
              <p className="amount">LKR {averagePerRide.toLocaleString()}</p>
              <p className="subtext">Across all completed rides</p>
            </div>
          </div>
          
          <div className="earnings-card upcoming-earnings">
            <div className="card-icon">🔄</div>
            <div className="card-content">
              <h3>Upcoming Earnings</h3>
              <p className="amount">LKR {upcomingEarnings.toLocaleString()}</p>
              <p className="subtext">From {scheduledRides} scheduled rides</p>
            </div>
          </div>
        </div>

        {/* Monthly Earnings Chart */}
        <div className="earnings-chart-section">
          <h2>Monthly Earnings</h2>
          <div className="chart-container">
            {monthlyEarnings.length > 0 ? (
              <div className="bar-chart">
                {monthlyEarnings.map((month, index) => (
                  <div key={index} className="chart-bar-container">
                    <div className="chart-bar" style={{ height: `${(month.amount / maxMonthlyEarnings) * 100}%` }}>
                      <span className="bar-amount">LKR {month.amount.toLocaleString()}</span>
                    </div>
                    <div className="chart-label">{month.month}</div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-data">No earnings data available for the past months</p>
            )}
          </div>
        </div>

        {/* Recent Transactions */}
        <div className="recent-transactions">
          <h2>Recent Rides & Earnings</h2>
          {recentRides.length > 0 ? (
            <div className="transactions-list">
              {recentRides.map(ride => (
                <div key={ride.id} className="transaction-item">
                  <div className="transaction-info">
                    <div className="ride-id">Ride #{ride.tourId}</div>
                    <div className="ride-date">
                      {new Date(ride.tourDate).toLocaleDateString()} at {ride.tourTime}
                    </div>
                    <div className="ride-route">
                      {ride.pickupLocation} → {ride.dropLocation}
                    </div>
                  </div>
                  <div className="transaction-amount">
                    <div className="amount">LKR {ride.tourCharges}</div>
                    <div className={`status ${ride.status}`}>{ride.status}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-data">No recent rides found</p>
          )}
        </div>

        {/* Earnings Goals */}
        <div className="earnings-goals">
          <h2>Earnings Goals</h2>
          <div className="goals-container">
            <div className="goal-card">
              <h3>Daily Goal</h3>
              <div className="goal-progress">
                <div className="progress-bar">
                  <div 
                    className="progress-fill" 
                    style={{ width: `${(todayEarnings / 5000) * 100}%` }}
                  ></div>
                </div>
                <div className="goal-amount">
                  <span>LKR {todayEarnings.toLocaleString()} / LKR 5,000</span>
                </div>
              </div>
            </div>
            
            <div className="goal-card">
              <h3>Weekly Goal</h3>
              <div className="goal-progress">
                <div className="progress-bar">
                  <div 
                    className="progress-fill" 
                    style={{ width: `${(weeklyEarnings / 25000) * 100}%` }}
                  ></div>
                </div>
                <div className="goal-amount">
                  <span>LKR {weeklyEarnings.toLocaleString()} / LKR 25,000</span>
                </div>
              </div>
            </div>
            
            <div className="goal-card">
              <h3>Monthly Goal</h3>
              <div className="goal-progress">
                <div className="progress-bar">
                  <div 
                    className="progress-fill" 
                    style={{ width: `${(totalEarnings / 100000) * 100}%` }}
                  ></div>
                </div>
                <div className="goal-amount">
                  <span>LKR {totalEarnings.toLocaleString()} / LKR 100,000</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Download Report Button */}
        <div className="report-section">
          <button className="btn-download-report" onClick={handleDownloadReport}>
            📄 Download Earnings Report
          </button>
        </div>
      </>
    )}
  </div>
)}


    

{/******************************************************************************************************************************/}


 {activeTab === "reachSupport" && (
<>
      <h1 className="contact-heading">Contact Admin</h1>

      {success && <p className="success-msg">✅ Your request has been sent!</p>}

    <form className="contact-form" onSubmit={handleSubmit}>
  {/* Name + Email Row */}
  <div className="form-row">
    <div className="form-group">
      <label>Name</label>
      <input type="text" value={driver?.name || ""} disabled />
    </div>

    <div className="form-group">
      <label>Email</label>
      <input type="email" value={driver?.email || ""} disabled />
    </div>
  </div>

  {/* Query Type + Subject Row */}
  <div className="form-row">
    <div className="form-group">
      <label>Query Type</label>
      <select
        name="queryType"
        value={formData.queryType}
        onChange={handleChange}
      >
        <option value="">-- Select Type --</option>
        <option value="Inquiry">Inquiry</option>
        <option value="Request">Request</option>
        <option value="Complaint">Complaint</option>
      </select>
    </div>

    <div className="form-group">
      <label>Subject</label>
      <input
        type="text"
        name="subject"
        value={formData.subject}
        onChange={handleChange}
        placeholder="Enter subject"
      />
    </div>
  </div>

  {/* Message Full Width */}
  <div className="form-group">
    <label>Message</label>
    <textarea
      name="message"
      rows="5"
      value={formData.message}
      onChange={handleChange}
      placeholder="Write your message..."
    />
  </div>

  <button type="submit" className="submit-btn" disabled={loading}>
    {loading ? "Sending..." : "Send Message"}
  </button>
</form>
   </>
)}



{/******************************************************************************************************************************/}


      </div>
    </div>
  );
}

export default DriverPanel;
